import styled from "styled-components";
import { styledByTheme } from "../../../themes/architecture/styled-by-theme";
import { UserMenuSectionIconBox } from "../../user-menu/user-menu/boxes/user-menu-section-icon.box";

const UserBalanceSectionIconDefaultBox = styled(UserMenuSectionIconBox)`
    /* .user-menu-box-icon */
    background-position: -615px -631px;
`;

/* 777 */
const UserBalanceSectionIconCasino777Box = styled(UserMenuSectionIconBox)`
    /* .user-menu-box-icon */
    background-position: -697px -568px;
`;

export const UserBalanceSectionIconBox = styledByTheme(UserBalanceSectionIconDefaultBox)
    .forCasino777(UserBalanceSectionIconCasino777Box)
    .apply();
